import React from 'react'
import 'react-day-picker/lib/style.css'
import './styles.scss'
import DayPickerInput from 'react-day-picker/DayPickerInput'

export default DayPickerInput
